// extracted by mini-css-extract-plugin
module.exports = {"badge":"badge-1RJ6R","clickable":"clickable-1Y36Z","invert":"invert-3N5oq","badge__count":"badge__count-1BJGa"};